// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JKQL","footer":"styles_footer__229vx","passCodeTooltip":"styles_passCodeTooltip__1YTJ8"};